import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
export const Tab = ({ active, disabled, id, children, name, onChange, value, className, ...rest }) => {
    const classes = classNames(className, "eds-tab", {
        "eds-tab--active": active,
    });
    const handleChange = (event) => {
        if (disabled !== true) {
            if (onChange)
                onChange(event);
        }
    };
    return (_jsx("li", { role: "tab", "aria-selected": active, children: _jsxs("label", { htmlFor: id, className: classes, children: [_jsx("input", { type: "radio", name: name, id: id, value: value || id, checked: active, disabled: !!disabled, onChange: handleChange, ...rest }), _jsx("div", { className: "eds-tab__focus-ring", children: children })] }) }));
};
